import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_f213bf9ae7: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_f213bf9ae7",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Tactile Learning & Stories",
  description:
    "Restock your bestselling section with the interactive and educational board books that have become a cornerstone of your recent inventory.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
    "https://cdn.faire.com/fastly/e7a0e36f08404053d5b89f50fe918b1c74a026397435baa87477511010157362.jpeg",
    "https://cdn.faire.com/fastly/d93c5a8a48eef44496fb063c35b0970cb85766e81638a1e25185a332644321fc.png",
    "https://cdn.faire.com/fastly/296f7e7c93dc099e1606a8055d96c5ad839687ba661e20ea6578439d6a9f3438.jpeg",
    "https://cdn.faire.com/fastly/9db824a51566c7a457e37241b8f810eda7ac30b1996a0bb0c990b47269949008.jpeg",
    "https://cdn.faire.com/fastly/c2a925cf9e16e1c1b094d9c9e8b1c5aed24d26c7f34d7571ce304b0043ef30db.jpeg",
  ],
  itemCount: 55,
  source: "eric_themes_ideas",
  teaser: "thi_f213bf9ae7",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
